package songwritersnotebook.app.utils

actual class NotificationManager actual constructor() {
    actual fun scheduleDailyReminder() {}
    actual fun cancelDailyReminder() {}
    
    actual fun setNewsAndUpdatesSubscription(enabled: Boolean) {
    }
}
